module.exports = __webpack_public_path__ + "static/media/MedSchool.1a7559e2.jpg";